module.exports = __webpack_public_path__ + "static/media/3.56222c17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/3.png
// module id = 1486
// module chunks = 1